import type { ReactNode } from "react";

import styles from "./Container.module.css";

interface Props {
  children: ReactNode;
  as?: "div" | "section" | "article";
}

export function Container({ children, as = "div" }: Props) {
  const Component = as;
  return <Component className={styles.container}>{children}</Component>;
}
